import { appConfig } from "src/appConfig";
import { openSafeUrl } from "src/helpers/urlHelper";

export const openVirtualScreen = (industry?: string) => {
  const url = industry
    ? `${appConfig.virtualScreenUrl}?industry=${industry}`
    : appConfig.virtualScreenUrl;
  openSafeUrl(url, "_blank");
};
